import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import Layout from '@/components/layout/Layout.vue';
import { LocalStorage } from '@/enums/storage.enum';
import store from '@/store';
import { homeRoute } from './layout/home.route';
import { cardRoute } from './layout/card.route';
import { partnerContainerRoute } from './layout/partners.container';
import { instructionRoute } from './layout/Instruction.route';
import { eventsContainerRoute } from './layout/events.container';
import { historyRoute } from './layout/history.route';
import { settingsContainerRoute } from './layout/settings.container';
import { applicationRoute } from './layout/application.route';
import { containerPointsRoute } from './layout/containerPoints.route';

Vue.use(VueRouter);

export const layoutRoute: RouteConfig = {
  path: '/',
  component: Layout,
  meta: {
    authorized: true,
    title: 'Twoja Karta'
  },
  name: 'main',
  redirect: { name: 'home' },
  children: [
    applicationRoute,
    cardRoute,
    eventsContainerRoute,
    historyRoute,
    homeRoute,
    instructionRoute,
    partnerContainerRoute,
    settingsContainerRoute,
    containerPointsRoute
  ],
  beforeEnter: (to, from, next) => {
    store.commit('profile/setId', localStorage.getItem(LocalStorage.USER_ID));
    store.dispatch('auth/updateTokenOnExpire');
    Promise.all([store.dispatch('profile/get'), store.dispatch('card/list'), store.dispatch('application/list')]).then(
      ([profile]) => {
        const changePasswordRouteName = 'changePassword';
        if (profile.needsPasswordChange && to.name !== changePasswordRouteName) {
          return next({ name: changePasswordRouteName });
        }
        next();
      }
    );
  }
};
